import React from "react";
import TabAddReview from "./page-components/review/TabAddReview";
import TabViewReview from "./page-components/review/TabViewReview";
import MasterPageTab from "./page-essential/MasterPageTab";

const Review = () => {
  return (
    <MasterPageTab
      addBtn="Add Review"
      addTab={<TabAddReview />}
      viewBtn="View Reviews"
      viewTab={<TabViewReview />}
      pageHeading="Package Reviews"
      pageDescription="Add/modify/delete reviews"
      icon={null}
    />
  );
};

export default Review;
